<template>
  <div id="slider" class="container row">

    <swiper :options="swiperOption" ref="mySwiper" @click="onclick">

      <swiper-slide v-for="g in gifs" :style="{ 'background-image': 'url(' + g.gif + ')' }" :key="g.id" class="swiper-lazy">
        <div class="caption">
          <div class="title-bg"><p class="title">{{ g.title }}</p></div>
          <div class="note-bg"><p class="note">{{ g.note }}</p></div>
        </div>
      </swiper-slide>


      <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>

    </swiper>

  </div>
</template>
<script>

  import thisismApi from '../api/thisism-api'
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'

  export default {
    data () {
      return {
        gifs: [],
        // heros: [
        //   {
        //     gif: 'https://s3-ap-northeast-1.amazonaws.com/thisism-gifs/Rotating_earth_(large).gif',
        //     title: 'Monthly Too Smell Records Feburary',
        //     note: 'Monthly Too Smell Records, Feburary 2016'
        //   },
        //   {
        //     gif: 'https://s3-ap-northeast-1.amazonaws.com/thisism-gifs/ezgif.com-video-to-gif+2.gif',
        //     title: 'ホーリーヤマザキ【Chpt.1】',
        //     note: 'Thisism presents 『ホーリーヤマザキ』CHAPTER ONE \'Holy Holy Holy\''
        //   },
        //   {
        //     gif: 'https://s3-ap-northeast-1.amazonaws.com/thisism.jp/gifs/gifsample03.gif',
        //     title: 'ユウTube 1st Episode',
        //     note: 'Thisism presents 『ユウTube』1st Episode http://blog.livedoor.jp/thisism/'
        //   }
        // ],
        swiperOption: {
          spaceBetween: 30,
          centeredSlides: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          // paginationClickable: true,
//                    nextButton: '.swiper-button-next',
//                    prevButton: '.swiper-button-prev',
//                    spaceBetween: 30,
//           effect: 'coverflow',
//                    autoHeight: true,
          autoplay: {
            delay: 12000
          }
        }

      }
    }, // end data
    computed: {
      swiper () {
        return this.$refs.mySwiper.swiper
      }
    },
    methods: {
      onclick () {
        const clicked = this.gifs[this.$refs.mySwiper.swiper.clickedIndex]
        this.$router.push({name: 'video-player', params: {ytid: clicked.ytid}})
      }
    },
    components: {
      swiper,
      swiperSlide
    },
    mounted () {
      thisismApi.getGifs().then(data => {
        this.gifs = data
      })
      // this.swiper.slideTo(0, 1000, false)
    }
    // created () {
    //   thisismApi.getGifs().then(data => {
    //     this.gifs = data
    //   })
    // }
  }// end export default
</script>
<style lang="scss" scoped>

  #slider {
    /*position: relative;*/
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
    box-sizing: border-box;
    height: 400px;
  }

  .swiper-container {
    /* border: solid 10px $color_black; */
    border-top: none;
  }

  .swiper-wrapper {

  }

  .swiper-slide {
    background-position: center;
    background-size: cover;

    width: 960px;
    height: 400px;
  }

  .swiper-pagination {
    /*position: relative;*/
    /*background-color: red;*/
    /*top: 1%;*/
    /*height: 50px;*/
    /*width: 100%;*/
  }

  .slide_image {
    background-size: cover;
    background-position: right;

    width: 960px;
    height: 400px;

  }

  .caption {

    //color: $color_white;

    position: absolute;
    bottom: 35px;
    left: 20px;

    padding: 10px;
    /*opacity: 0.8;*/

    display: inline-block;
    /*background-color: black;*/

  }

  .title-bg {

    padding: 10px;
    background-color: black;
    opacity: 0.7;
    height: 50px;

    .title {
      line-height: 30px;
      color: white;
      opacity: 1;
      font-size: 3rem;
    }

  }

  .note-bg {
    /*display: inline-block;*/
    /*background-color: black;*/
    opacity: 0.7;
  }


</style>




// WEBPACK FOOTER //
// Slider.vue?2e287374